class PhnArticleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.#initShareButtons();
    this.#formatListItems();
  }

  #initShareButtons() {
    const shareBtns = this.querySelectorAll('[data-share-trigger]');
    for (const btn of shareBtns) {
      btn.addEventListener('click', this.#handleShare.bind(this));
    }
  }

  #handleShare() {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: window.location.href
      }).catch(console.error);
    } else {
      prompt('Copy this link to share:', window.location.href);
    }
  }

  #formatListItems() {
    const elements = this.querySelectorAll('span');
    for (const element of elements) {
      const text = element.textContent.trim();
      if (text.startsWith('•')) {
        element.classList.add('list-item');
      }
    }
  }
}

if (!customElements.get('phn-article-content')) {
  customElements.define('phn-article-content', PhnArticleContent);
}
